import {getCheckoutSummary, getPaidPlanPercentDiscount, getTaxLabel} from '@wix/wix-events-commons-statics'
import {detailsPageDataHooks as DH} from '@wix/wix-events-data-hooks'
import {Text} from '@wix/wix-ui-tpa/cssVars'
import {useTranslation} from '@wix/yoshi-flow-editor'
import React from 'react'
import {useCurrencyFormatter} from '../../../../../../../commons/hooks/currency'
import {useAppSelector} from '../../../../hooks/runtime'
import {getGiftCardPaymentDetails} from '../../../../selectors/invoice'
import {getInvoice} from '../../../../selectors/placed-order'
import {SummaryRow} from '../summary-row'
import {classes} from './total-breakdown.st.css'

export const TotalBreakdown = () => {
  const {t} = useTranslation()
  const {getFormattedMoney} = useCurrencyFormatter()

  const invoice = useAppSelector(getInvoice)
  const giftCardPaymentDetails = useAppSelector(getGiftCardPaymentDetails)

  const {subtotal, tax, addedFee, discount, paidPlanDiscount, total, buyerTotal, giftCards} = getCheckoutSummary(
    invoice,
    getFormattedMoney,
    giftCardPaymentDetails,
  )

  if (!subtotal && !total) {
    return null
  }

  return (
    <div data-hook={DH.INVOICE_BREAKDOWN}>
      {subtotal && (
        <div className={classes.subTotals}>
          <SummaryRow label={t('ticketsPicker.subtotal')} value={subtotal} dataHook={DH.SUBTOTAL} />
          <SummaryRow
            label={t('ticketsThankYou.paidPlan', {discount: getPaidPlanPercentDiscount(invoice)})}
            value={paidPlanDiscount}
            dataHook={DH.PAID_PLAN_DISCOUNT_PRICE}
          />
          <SummaryRow label={t('ticketsThankYou.coupon')} value={discount} dataHook={DH.DISCOUNT_PRICE} />
          <SummaryRow label={getTaxLabel(invoice)} value={tax} dataHook={DH.TAX} />
          <SummaryRow label={t('checkout_serviceFee')} value={addedFee} dataHook={DH.WIX_FEE} />
          {giftCards?.map((giftCard, index) => (
            <SummaryRow
              key={index}
              dataHook={DH.GIFT_CARD(index)}
              label={t('checkout_giftCard')}
              value={`-${giftCard.amount}`}
            />
          ))}
        </div>
      )}
      <div className={classes.total} data-hook={DH.TOTAL_PRICE}>
        <Text>{t('mobile.ticketsPicker.total')}</Text>
        <Text>{buyerTotal}</Text>
      </div>
    </div>
  )
}
